import React from "react";

import { mapValues } from "lodash";
import { hot } from "react-hot-loader";
import ReactOnRails from "react-on-rails";

// Configure ReactOnRails to use Turbo's lifecycle events
// for mounting and unmounting components, instead of the default DOMContentLoaded.
ReactOnRails.setOptions({
  turbo: true,
  traceTurbolinks: process.env.NODE_ENV !== "production", // Optional: for debugging
});

// Define a more specific type for Webpack's `module` object with HMR properties.
interface HotModule {
  hot?: {
    accept(dependencies: string[], callback: (updatedDependencies: string[]) => void): void;
    accept(dependency: string, callback: () => void): void;
    accept(errHandler?: (err: Error) => void): void;
    dispose(callback: (data: any) => void): void;
    status(): string;
  };
}

type Components = Record<string, React.ComponentType<any>>;

export default {
  /**
   * A wrapper around the base ReactOnRails.register function that applies
   * react-hot-loader to all registered components in development.
   * @param components - An object where keys are component names and values are the components.
   * @param fromModule - The `module` object from the calling file, used for HMR.
   */
  register(components: Components, fromModule: HotModule) {
    let componentsToRegister = components;

    // In development, wrap components with the HMR higher-order component.
    if (fromModule?.hot) {
      const withReloading = hot(fromModule);
      componentsToRegister = mapValues(components, (Component) => withReloading(Component));

      // According to the react-hot-loader docs, we should not re-register on hot-update,
      // as the HOC handles the swapping.
      if (fromModule.hot.status() === "apply") {
        return;
      }
    }

    ReactOnRails.register(componentsToRegister);
  },
};
